import { styled } from '@mui/material/styles';
import { Input as InputBase } from '@mui/material';
import { MagnifyingGlass } from '@phosphor-icons/react';

export const Input = styled(InputBase)(({ theme }) => ({
  paddingRight: theme.spacing(2.5),
}));

export const Icon = styled(MagnifyingGlass)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1.5),
}));
